import {Task} from '@features/rcfa-list'
import {ApiClient} from '@hconnect/apiclient'
import {OrderByApiProperty, ApiFilter} from '@hconnect/common/maintain-filters'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export type PagePermissions = {
  canCreateAnalysis: boolean
}

export type ResponseType = {
  currentPage: number
  data: Array<Task>
  totalCount: number
  permissions: PagePermissions
}

export const QueryKey = 'tasks-master-list'

export const useGetTasksList = (
  page: number,
  rowsNumber: number,
  filters?: ApiFilter[],
  order?: OrderByApiProperty[],
  options?: UseQueryOptions<ResponseType, AxiosError>
) => {
  return useQuery<ResponseType, AxiosError>({
    queryKey: [QueryKey, page, rowsNumber, filters, order],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/analyses/tasks'
      return (
        await ApiClient.axiosInstance.post<ResponseType>(
          path,
          {pageSize: rowsNumber, pageNumber: page, filters, orderBy: order},
          {}
        )
      ).data
    },

    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
